import { useQuery } from "@tanstack/react-query";
import { fetchWorkforceProfiles } from "PFCore/services/booking/fetch_workforce_profiles";
import { CalendarRange, OrderOption, PaginatedCollection, Profile, QueryOptions } from "PFTypes";

import { workforceKeys } from "./query_keys";

export type WorkforceItem = {
  profile: Pick<Profile, "id" | "firstName" | "lastName" | "positions" | "suspendedAt" | "availability"> & {
    hasBookings: boolean;
  };
  scores?: Record<string, any>;
  id: number;
  optionalFields: Record<string, any>;
};

export type WorkforceResponse = PaginatedCollection<
  WorkforceItem[],
  {
    totalBillableUtilization?: number;
    dynamicWmInfoCustomTypes?: Record<number, string>;
    searchId?: number;
  },
  {
    filteredProfilesCount: number;
    endpointLimit: number;
    filteredActiveProfilesCount: number;
  }
>;

type UseWorkforceEntries = {
  page: number;
  perPage: number;
  order: OrderOption | null;
  filters: any;
  dateRange: CalendarRange;
  previousSearchId: number | undefined;
  options: QueryOptions<WorkforceResponse, { status: number }>;
};

export const useWorkforceEntries = ({
  page = 1,
  perPage = 15,
  order,
  filters,
  dateRange,
  previousSearchId,
  options = {}
}: UseWorkforceEntries) =>
  useQuery<WorkforceResponse, { status: number }>({
    retry: false,
    queryKey: workforceKeys.withParameters(filters, order, dateRange, page, perPage),
    queryFn: async () =>
      fetchWorkforceProfiles({
        page,
        perPage,
        order: order ?? undefined,
        filters,
        dateRange,
        previousSearchId
      }),
    ...options,
    enabled: options.enabled ?? true
  });
